<template>
  <div class="label_box">
    <div class="label_display" :class="{'none': !selectProfile.length}" @click="showDialog = true">{{ displayStr }}</div>
    <span class="suffix">
      <i :class="['el-icon-arrow-up', showDialog ? 'reverse' : '']"></i>
    </span>
    <el-dialog
      title="CPR+标签"
      width="790px"
      custom-class="ad-cprplus-label-pop"
      :append-to-body="true"
      :close-on-click-modal="false"
      :visible.sync="showDialog">
      <div class="pop_content">
        <div class="top">标签选择</div>
        <CprPlusPop v-model="profileData"></CprPlusPop>
      </div>
      <span slot="footer">
        <div class="fix-btn red" @click="confirmDmpLabel">确定</div>
        <div class="fix-btn" @click="closeDmpDialog">取消</div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CprPlusPop from './CprPlusLabelPop'

export default {
  name: 'DmpLabelSelect',
  components: { CprPlusPop },
  props: {
    value: Array
  },
  data () {
    return {
      showDialog: false,
      profileData: [],
      profileConfirm: []
    }
  },
  computed: {
    // 有选择标签的用户画像
    selectProfile() {
      return this.profileConfirm.filter(e => e.list && e.list.length)
    },
    displayStr () {
      if (this.selectProfile.length) {
        if (this.selectProfile.length === 1) return this.selectProfile[0].list.map(t => t.name).join('+')
        return this.selectProfile.map(cur => {
          const str = cur.list.map(t => t.name).join('+')
          return cur.list.length === 1 ? str : `(${str})` // 画像下只有一个标签时不展示括号
        }).join(' 或 ')
      }
      return '选择CPR+标签'
    }
  },
  watch: {
    value (v) { // 取消展开之后 选中确定的数据状态
      // console.log('vvvvv:', v)
      // this.profileData = JSON.parse(JSON.stringify(v))
    }
  },
  methods: {
    closeDmpDialog () {
      this.showDialog = false
      this.profileData = JSON.parse(JSON.stringify(this.profileConfirm)) // 复原数据,深拷贝保存确认数据,以免联动影响
    },
    confirmDmpLabel () {
      if (this.hasSame(this.profileData)) return this.messageTip('画像数据不能重复', 2)
      this.profileConfirm = this.profileData
      this.closeDmpDialog()
      this.$emit('input', this.selectProfile.map(e => e.list.map(s => s.code)))
    },
    hasSame (list) {
      const all = list.map(e => e.list.map(e => e.code).sort().join('')).filter(e => e)
      const set = [...new Set(all)]
      return all.length > set.length
    }
  }
}
</script>

<style lang="scss" scoped>
.label_box {
  position: relative;
  padding-left: 10px;
  .suffix {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    .el-icon-arrow-up {
      cursor: pointer;
      color: #C0C4CC;
      transition: transform .3s;
      transform: rotateZ(180deg);
      &.reverse {
        transform: rotateZ(0);
      }
    }
  }
  .label_display {
    cursor: pointer;
    width: calc(100% - 30px);
    &.none {
      color: #C0C4CC;
    }

  }
}
.pop_content {
  box-shadow: 0 0 0 1px #e9e9e9;
  height: 100%;
  overflow: auto;
  .top {
    background: #F5F5F5;
    font-weight: 550;
    text-align: left;
    padding-left: 20px;
    line-height: 40px;
  }
}
</style>

<style lang="scss">
.ad-cprplus-label-pop {
  text-align: center;
  top: 50%;
  margin-top: -260px !important;
  .el-dialog__body {
    padding: 20px;
    height: 420px;
    border-top: 1px solid #E9E9E9;
    border-bottom: 1px solid #E9E9E9;
  }
  .el-dialog__footer {
    padding: 0;
    text-align: center;
  }
}
</style>
